import React, {useRef, useState} from 'react'
import SignaturePad from 'react-signature-canvas'
import {Button, FormControl, Grid, FormHelperText} from '@material-ui/core'
export default function WSignatureField({data, onChange}) {
  const [signature, setSignature] = useState(null)
  const [show, setShow] = useState(false)
  let sigPad = useRef({})
  const clear = () => {
    setSignature('true')
    setShow(false)
    sigPad.clear()
  }
  const save = e => {
    let trimmedSignURL = sigPad.getTrimmedCanvas().toDataURL('image/png')
    setSignature(trimmedSignURL)
    onChange(
      {
        target: {
          value: trimmedSignURL,
        },
      },
      'value',
      data
    )
  }
  return (
    <>
      <FormControl
        fullWidth
        variant="outlined"
        className="ap-textfield"
        style={{width: 320, border: '1px solid'}}
      >
        <SignaturePad
          canvasProps={{
            width: 320,
            height: 150,
            className: `${(signature === null && data?.value) || show ? 'd-none' : ''}`,
          }}
          ref={ref => {
            sigPad = ref
          }}
        />
        {signature === null && data?.value && (
          <div className="signature-pad-show">
            <img src={data?.value} width="auto" alt="signature-pad" />
          </div>
        )}
        <Grid container>
          <Grid item xs={6}>
            <Button onClick={clear}>Clear</Button>
          </Grid>
          <Grid item xs={6}>
            <Button onClick={save}>Save</Button>
          </Grid>
        </Grid>
        <FormHelperText>{!data.is_required ? 'optional' : ''}</FormHelperText>
      </FormControl>
    </>
  )
}
